import {
  createFppSearchFilterReducer,
  SearchFilterState,
} from "@/features/search-filter/redux/reducer";
import { combineReducers } from "redux";

export interface StatisticsByAgreedVolumeState {
  filter: SearchFilterState;
}

export const statisticsByAgreedVolumeReducer =
  combineReducers<StatisticsByAgreedVolumeState>({
    filter: createFppSearchFilterReducer("statistics.statisticsByAgreedVolume"),
  });
